import { gql, TypedDocumentNode } from '@apollo/client'
import { UnauthorizedError, InvalidParameterError } from '../../containers/errorTypes'

export interface SendTowingOrderSmsMutationVariables {
  input: {
    towingOrderId: number
    phone: string
    message: string
  }
}

export interface SendTowingRecordSmsMutationVariables {
  input: {
    towingRecordId: number
    phone: string
    message: string
  }
}

interface SendTowingOrderSmsSuccess {
  __typename: 'SendTowingOrderSmsSuccess'
  success: boolean
  message?: string | null
}

interface SendTowingRecordSmsSuccess {
  __typename: 'SendTowingRecordSmsSuccess'
  success: boolean
  message?: string | null
}

export type SendTowingOrderSmsMutation = {
  sendTowingOrderSms: SendTowingOrderSmsSuccess | UnauthorizedError | InvalidParameterError
}

export type SendTowingRecordSmsMutation = {
  sendTowingRecordSms: SendTowingRecordSmsSuccess | UnauthorizedError | InvalidParameterError
}

export const SEND_TOWING_ORDER_SMS: TypedDocumentNode<
  SendTowingOrderSmsMutation,
  SendTowingOrderSmsMutationVariables
> = gql`
  mutation SendTowingOrderSms($input: SendTowingOrderSmsInput!) {
    sendTowingOrderSms(input: $input) {
      __typename
      ... on SendTowingOrderSmsSuccess {
        success
        message
      }
      ... on UnauthorizedError {
        error {
          code
          message
        }
      }
      ... on InvalidParameterError {
        error {
          code
          message
        }
      }
    }
  }
`

export const SEND_TOWING_RECORD_SMS: TypedDocumentNode<
  SendTowingRecordSmsMutation,
  SendTowingRecordSmsMutationVariables
> = gql`
  mutation SendTowingRecordSms($input: SendTowingRecordSmsInput!) {
    sendTowingRecordSms(input: $input) {
      __typename
      ... on SendTowingRecordSmsSuccess {
        success
        message
      }
      ... on UnauthorizedError {
        error {
          code
          message
        }
      }
      ... on InvalidParameterError {
        error {
          code
          message
        }
      }
    }
  }
`
